import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "px-3 mt-4" }
const _hoisted_2 = { class: "pack-text text-grey-900" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2 d-none d-lg-flex" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mx-2 text-grey-900"
}
const _hoisted_7 = { class: "d-flex align-items-center me-1 flex-column" }
const _hoisted_8 = {
  width: "20",
  height: "20",
  class: "icon me-1"
}
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = { class: "package-label" }
const _hoisted_11 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center prestation-discount-container f bg-primary-orange ms-1 ms-xl-3"
}
const _hoisted_13 = { class: "mobile-packages-wrapper d-flex d-lg-none align-items-center justify-content-center mb-3 p-0 mt-3" }
const _hoisted_14 = {
  key: 0,
  class: "mx-1 text-grey-900"
}
const _hoisted_15 = { class: "d-inline-flex flex-column align-items-center" }
const _hoisted_16 = {
  width: "20",
  height: "20",
  class: "icon mb-1"
}
const _hoisted_17 = ["xlink:href"]

import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import PackagesMobileDropdown from "@/vue/planning/components/search/packagesMobileDropdown.vue"
import colors from "@/config/colors"
import { isABtest } from "@/utils/utils"
// import getPackageComposition from "../../logic/getPackageComposition"
import { isCS } from "@/vue/planning/logic/cs"
import packDisplayConfig from "@/config/packDisplayConfig"
import packageCompositionConfig, { PackageComponent } from "@/config/packageCompositionConfig"
import { transportPacks } from '@/config/transportPackagePriorities'
import { airportCodeMap } from '@/config/airportCodeMap'
import flightPackCode from '@/config/flightPackCode'
import trainPackCode from '@/config/trainPackCode'
import { trainStationCodeMap } from '@/config/trainStationCodeMap'
import { Transport } from '@/types'

// Utils 
import { hasChangedTransportType } from "@/utils/transportation"

// Computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"
import getSiteFromDomain from '../../logic/getSiteFromDomain'
import displayPrice from '@/displayPrice/displayPrice'

type PackPromo = { perCent: number; perValue: number }

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'packages',
  setup(__props) {

const store = useStore()

// Reactive data
const localPackagesToDisplay = ref<{ codePackage: string, packageId?: string }[]>([])

// Computed properties
const content = computed(() => store.state.content)
const packagesMobileDropdownOpen = computed(() => store.state.packagesMobileDropdownOpen)
const loading = computed(() => store.state.loading)
const packCode = computed(() => store.state.packCode)
const packageId = computed(() => store.state.packageId)
const dates = computed(() => store.state.dates)

// const maxPromosFromAvailablePackages = computed(() => store.getters.maxPromosFromAvailablePackages)
const availablePackCodes = computed(() => store.getters.availablePackCodes)

const isLocaleNL = computed(() => store.getters.isLocaleNL)
const isLocaleEN = computed(() => store.getters.isLocaleEN)

const effectivePackagesToDisplay = computed(() => {
	let result = [];

	if (localPackagesToDisplay.value && localPackagesToDisplay.value.length > 0) {
		result = localPackagesToDisplay.value;
	} else if (packagesToDisplay.value && packagesToDisplay.value.length > 0) {
		result = packagesToDisplay.value;
	} else if (availablePackCodes.value && availablePackCodes.value.length > 0) {
		result = availablePackCodes.value;
	}

	return result;
})

const promoString = computed(() => {
	const promoString: Map<string, string> = new Map();
	availablePackCodes.value.forEach((packObj: { codePackage: string, packageId?: string }) => {
		// console.log("XXX packObj.codePackage", packObj.codePackage, "promos.value[packObj.codePackage as keyof typeof promos.value]", promos.value[packObj.codePackage as keyof typeof promos.value])
		if (getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com") {
			promoString.set(packObj.codePackage, `-${displayPrice(promos.value[packObj.codePackage as keyof typeof promos.value].perValue*100, store.getters.locale)}`);
		} else {
			promoString.set(packObj.codePackage, `-${promos.value[packObj.codePackage as keyof typeof promos.value].perCent}%`);
		}
	});
	return promoString;
});

const promos = computed((): Record<string, PackPromo> => {
	const rawData = store.getters.getWiypCallByFamilyComposition(store.state.participants.join('-')) || {};
	const promoObject: Record<string, PackPromo> = {};
	if (rawData && typeof rawData === 'object') {
		availablePackCodes.value.forEach((packObj: { codePackage: string, packageId?: string }) => {
			// We NEED to load prestIdFusion/prestIdSource from prestmaps but we do not have them
		
			let maxPromo: PackPromo = { perCent: 0, perValue: 0 };
			// Loop through all values (usually just one key, but future-proof)
			// { "LON": { "PFF": {"1000000032": {wiypPrices: [{publicPriceWiyp: 100, sellingPriceWiyp: 90}]}}}}
			Object.values(rawData).forEach((valueOriginObject: any) => {
				/* 	"PFF": { "1000000031": { "wiypPrices": [{"sellingPriceWiyp": 5233.55,"publicPriceWiyp": 4951.33},{"sellingPriceWiyp": 4115.29,"publicPriceWiyp": 3916.55}]}}	*/
				Object.entries(valueOriginObject).forEach(([packageCode, valuePackageObject]: [string, any]) => {
					/* "1000000031": { "wiypPrices": [{"sellingPriceWiyp": 5233.55,"publicPriceWiyp": 4951.33},{"sellingPriceWiyp": 4115.29,"publicPriceWiyp": 3916.55}]} */
					if ( packageCode === packObj.codePackage && valuePackageObject && typeof valuePackageObject === 'object' ) {
						Object.values(valuePackageObject).forEach((valuePackageIdObject: any) => {
							/* "wiypPrices": [{"sellingPriceWiyp": 5233.55,"publicPriceWiyp": 4951.33},{"sellingPriceWiyp": 4115.29,"publicPriceWiyp": 3916.55}] */
							if (valuePackageIdObject && Array.isArray((valuePackageIdObject as any).wiypPrices)) {
								(valuePackageIdObject as any).wiypPrices.forEach((promoPrice: any) => {
									// console.log("XXX promoPrice", JSON.stringify(promoPrice, null, 2))
									// need to check that prestId is in variant
									if (
										typeof promoPrice.publicPriceWiyp === 'number' &&
										typeof promoPrice.sellingPriceWiyp === 'number' &&
										promoPrice.publicPriceWiyp !== 0
									) {
										const promo = Math.round(
											((promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) /
												promoPrice.publicPriceWiyp) *
												100
										);
										if (promo > maxPromo.perCent) {
											maxPromo = { perCent: promo, perValue: Math.floor(promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp)};
										}
									}
								});
							}	
						});
					}
				});
			});	
			promoObject[packObj.codePackage] = maxPromo;		
		})
	}

	return promoObject;
})


const addDnoneClassIfABtest = computed(() => {
	const dNoneClass = isABtest() ? "d-none !important" : ""
	return dNoneClass
})

const showBadge = (codePackage: string) => {
	if (codePackage === 'HS') return false;
	if (getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com") {
		return promos.value[codePackage as keyof typeof promos.value] && promos.value[codePackage as keyof typeof promos.value].perValue >= 100;
	}
	return promos.value[codePackage as keyof typeof promos.value] && promos.value[codePackage as keyof typeof promos.value].perCent > 5;
}

// Methods
const handlePackageChange = async (packObj: { codePackage: string, packageId?: string }) => {
	const isTransportPack = transportPacks.includes(packObj.codePackage)
	if (packCode.value === packObj.codePackage) {
		store.dispatch("setPackagesMobileDropdownOpen", false)
		return
	}

	// Not anymore in use - use availability service instead
	// // First update package composition if needed
	// if (packObj.codePackage !== "HS" && !isCS(packObj)) {
	// 	await getPackageComposition(store)
	// }

	const changedTransportType = hasChangedTransportType(store.state.packCode, packObj.codePackage, isTransportPack)
	const currentOrigin = store.state.flightOrigin?.split("-")[0] || ""
	const isCurrentOriginFlight = airportCodeMap.has(currentOrigin)
	const isCurrentOriginTrain = trainStationCodeMap.has(currentOrigin)
	const isFlightPackage = flightPackCode.includes(packObj.codePackage)
	const isTrainPackage = trainPackCode.includes(packObj.codePackage)
	// Capture before setPackage — participants watcher may truncate during the switch
	const shouldOpenParticipantsDropdown =
		(isFlightPackage || isTrainPackage) && store.state.participants.length > 9

	// Then update the package
	await store.dispatch("setPackage", packObj.codePackage)
	store.commit("setPackageId", packObj.packageId)

	if (isFlightPackage) {
		store.commit("setTransportv2", Transport.FLIGHT)
		store.commit("setTransportationSelected", true)
		if (changedTransportType || isCurrentOriginTrain) {
			await store.dispatch("selectDefaultFlightOrigin", { overwrite: true, forceFlightPackCode: true })
		}
	} else if (isTrainPackage) {
		store.commit("setTransportv2", Transport.TRAIN)
		store.commit("setTransportationSelected", true)
		if (changedTransportType || isCurrentOriginFlight) {
			await store.dispatch("selectDefaultTrainOrigin", { overwrite: true, forceTrainPackCode: true })
		}
	} else {
		store.commit("setTransportv2", null)
		store.commit("setTransportationSelected", false)
		store.commit("setFlightOrigin", airportCodeMap.get("None")?.name)
	}

	if (shouldOpenParticipantsDropdown) {
		if (store.state.participants.length > 9) {
			await store.dispatch("setParticipants", store.state.participants.slice(0, 9))
		}
		// After package search / body click handlers that close dropdowns
		setTimeout(() => {
			store.dispatch("setParticipantsDropdownOpen", true)
		}, 0)
	}
}

const handleMobileDropdownOpen = () => {
	store.dispatch(
		"setPackagesMobileDropdownOpen",
		!packagesMobileDropdownOpen.value
	)
}

const getPackageCompositionConfig = (packageCode: string) => {
	const composition = packageCompositionConfig[packageCode]?.components || []
	return composition
}

const getContentKey = (component: PackageComponent) => {
	// Use short version for Dutch and English locales
	let keyToUse = component.contentKey;
	if ((isLocaleNL.value || isLocaleEN.value) && component.contentKeyShort) {
		keyToUse = component.contentKeyShort;
	}
	return content.value[keyToUse];
}

// Lifecycle
onMounted(() => {
	if ((!packagesToDisplay.value || packagesToDisplay.value.length === 0) &&
		availablePackCodes.value && availablePackCodes.value.length > 0) {
		localPackagesToDisplay.value = [...availablePackCodes.value]
	}
	store.dispatch("selectTransportWithDefaultPackage", store.state.transportationSelected);
})

// Watchers
watch(packCode, (newPackCode, oldPackCode) => {
	// Package code changed
}, { immediate: true })



watch(availablePackCodes, (newVal, oldVal) => {
	// Always preserve the packages list if we have one, even if new value is empty
	if (newVal && newVal.length > 0) {
		// We have new packages, use them
		if ((!packagesToDisplay.value || packagesToDisplay.value.length === 0)) {
			// Get sorted packages from packDisplayConfig
			const sortedPackages = [...newVal].sort((a, b) => {
				// Use imported packDisplayConfig
				const aIndex = packDisplayConfig.indexOf(a.codePackage);
				const bIndex = packDisplayConfig.indexOf(b.codePackage);
				return aIndex - bIndex;
			});
			localPackagesToDisplay.value = sortedPackages;
		}
	} else if (newVal && newVal.length === 0 && localPackagesToDisplay.value && localPackagesToDisplay.value.length > 0) {
		// New value is empty but we have existing packages, keep the existing ones
		// Don't change localPackagesToDisplay - preserve current packages
	}
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(content.value.planner_chooseFormula), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectivePackagesToDisplay.value, (packObj) => {
        return (_openBlock(), _createElementBlock("div", {
          key: packObj.codePackage,
          onClick: ($event: any) => (handlePackageChange(packObj)),
          class: _normalizeClass(["package-tab d-flex align-items-center justify-content-between p-3 col", packCode.value === packObj.codePackage ? 'active' : 'text-grey-900'
					])
        }, [
          _createElementVNode("span", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPackageCompositionConfig(
						packObj.codePackage
					), (component, componentIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${packObj.codePackage}-${componentIndex}`
              }, [
                (componentIndex > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                    _createElementVNode("use", {
                      "xlink:href": `#___icon___${component.icon}`
                    }, null, 8, _hoisted_9)
                  ])),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(getContentKey(component)), 1)
                ])
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (
						packObj.codePackage !== 'HS'
						&& showBadge(packObj.codePackage)
					)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap", addDnoneClassIfABtest.value])
                  }, _toDisplayString(promoString.value.get(packObj.codePackage)), 3)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        onClick: _withModifiers(handleMobileDropdownOpen, ["stop"]),
        class: "mobile-packages form-control py-3 cursor-pointer position-relative px-3 d-flex justify-content-between",
        style: _normalizeStyle([packagesMobileDropdownOpen.value && {
					'box-shadow': `0px 0px 4px 0px ${_unref(colors).lightBlue}`,
					color: _unref(colors).lightBlue,
				}
					, {"height":"initial"}])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["font-weight-600 d-flex align-items-center", getPackageCompositionConfig(packCode.value).length > 3 ? 'font-size-11' : getPackageCompositionConfig(packCode.value).length > 2 ? 'font-size-12' : 'font-size-14'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPackageCompositionConfig(packCode.value), (component, componentIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `mobile-header-${packCode.value}-${componentIndex}`
            }, [
              (componentIndex > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "+"))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_15, [
                (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                  _createElementVNode("use", {
                    "xlink:href": `#___icon___${component.icon}`
                  }, null, 8, _hoisted_17)
                ])),
                _createTextVNode(" " + _toDisplayString(getContentKey(component)), 1)
              ])
            ], 64))
          }), 128))
        ], 2),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-2" }, [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            class: "icon"
          }, [
            _createElementVNode("use", {
              "data-v-7fb4dc0e": "",
              "xlink:href": "#___icon___chevron-down-bold"
            })
          ])
        ], -1))
      ], 4)
    ]),
    _createVNode(PackagesMobileDropdown, {
      onValidateClick: _cache[0] || (_cache[0] = (newPackCode) => handlePackageChange(newPackCode))
    })
  ]))
}
}

})